var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3154 6.98265L12.9745 2.68676L14.4045 1.2548C14.796 0.862711 15.2771 0.666668 15.8477 0.666668C16.4176 0.666668 16.8983 0.862711 17.2898 1.2548L18.7198 2.68676C19.1113 3.07884 19.3156 3.55207 19.3326 4.10645C19.3496 4.66014 19.1624 5.13303 18.7708 5.52512L17.3154 6.98265ZM1.68837 19.3333C1.39898 19.3333 1.15657 19.2351 0.961148 19.0388C0.765044 18.8431 0.666992 18.6003 0.666992 18.3105V15.421C0.666992 15.2846 0.692527 15.1527 0.743595 15.0252C0.794664 14.897 0.871267 14.7817 0.973404 14.6795L11.4936 4.14429L15.8344 8.49132L5.31424 19.0265C5.2121 19.1288 5.09737 19.2055 4.97004 19.2566C4.84203 19.3078 4.70993 19.3333 4.57375 19.3333H1.68837Z",
    fill: "#5C5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.a927959ab78ba714811ffb05edf25e5c.svg";
export { ForwardRef as ReactComponent };